import { render, staticRenderFns } from "./UserPermissionsDialog.vue?vue&type=template&id=2e2c06dc&scoped=true"
import script from "./UserPermissionsDialog.vue?vue&type=script&lang=js"
export * from "./UserPermissionsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionsDialog.vue?vue&type=style&index=0&id=2e2c06dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c06dc",
  null
  
)

export default component.exports